import { combineReducers } from 'redux';
import { reducer as reducerForm } from 'redux-form';
import IState from '../models/IState';
import authReducer from './auth.reducer';
import preferencesReducer from './preferences.reducer';
import changePasswordReducer from './changePassword.reducer';
import userReducer from './user.reducer';
import sensorReducer from './sensor.reducer';
import sensorDataReducer from './sensorData.reducer';
import userSettingReducer from './usersetting.reducer';
import sensorDataChartReducer from './sensorDataChart.reducer';
import pagerReducer from './pager.reducer';
import downloadFileReducer from './downloadFile.reducer';
import iaqSensorDataReducer from './iaqSensorData.reducer';
import iaqSensorDataChartReducer from './iaqSensorDataChart.reducer';
import iaqRealtimeViewDataReducer from './iaqRealtimeViewData.reducer';
import iaqRealtimeViewChartReducer from './iaqRealtimeViewChart.reducer';
import iaqDevicesReducer from './iaqDevices.reducer';

export default combineReducers<IState>({
	form: reducerForm,
	auth: authReducer,
    preferences:preferencesReducer,
	changePassword:changePasswordReducer,
	user: userReducer,
	sensor: sensorReducer,
	sensorData: sensorDataReducer,
	column: userSettingReducer,
	sensorDataChart: sensorDataChartReducer,
	iaqSensorData: iaqSensorDataReducer,
	iaqSensorDataChart: iaqSensorDataChartReducer,
	pager: pagerReducer,
	file: downloadFileReducer,
	realtimeViewData: iaqRealtimeViewDataReducer,
	realtimeViewChartData: iaqRealtimeViewChartReducer,
	iaqDevices: iaqDevicesReducer
});
 